import { render, staticRenderFns } from "./FieldPostCode.vue?vue&type=template&id=3e8b4400&scoped=true"
import script from "./FieldPostCode.vue?vue&type=script&lang=js"
export * from "./FieldPostCode.vue?vue&type=script&lang=js"
import style0 from "./FieldPostCode.vue?vue&type=style&index=0&id=3e8b4400&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b4400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8b4400')) {
      api.createRecord('3e8b4400', component.options)
    } else {
      api.reload('3e8b4400', component.options)
    }
    module.hot.accept("./FieldPostCode.vue?vue&type=template&id=3e8b4400&scoped=true", function () {
      api.rerender('3e8b4400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/primer/localCardList/customFields/FieldPostCode.vue"
export default component.exports